module.exports = __webpack_public_path__ + "static/cloud-7f8e8547cdbe6482f989cb895112f92c.png";